<template>
	<svg
	  width="21"
	  class="fill-current"
	  height="20"
	  viewBox="0 0 21 20"
	  fill="none"
	  xmlns="http://www.w3.org/2000/svg"
	>
	  <path
		d="M15.6705 1.875H18.4272L12.4047 8.75833L19.4897 18.125H13.9422L9.59717 12.4442L4.62554 18.125H1.86721L8.30887 10.7625L1.51221 1.875H7.20054L11.128 7.0675L15.6705 1.875ZM14.703 16.475H16.2305L6.37054 3.43833H4.73137L14.703 16.475Z"
	  />
	</svg>
</template>
